import { atomWithStorage } from 'jotai/utils'

export const currentThemeAtom = atomWithStorage('theme', 'dark')
